import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useState, useEffect, createContext, useContext } from 'react';
import { useAuth } from '../hooks/useAuth';
import api from '../utils/api';

export const CompanyContext = createContext(null);
export const useCompany = () => useContext(CompanyContext);

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [activeCompany, setActiveCompany] = useState(null);

  useEffect(() => {
    api.get('/companies').then(r => {
      setCompanies(r.data);
      const saved = localStorage.getItem('activeCompanyId');
      const found = r.data.find(c => c.id === parseInt(saved)) || r.data[0];
      if (found) setActiveCompany(found);
    });
  }, []);

  const handleCompanyChange = (e) => {
    const company = companies.find(c => c.id === parseInt(e.target.value));
    setActiveCompany(company);
    localStorage.setItem('activeCompanyId', company.id);
  };

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <CompanyContext.Provider value={{ activeCompany, companies, setActiveCompany }}>
      <div className="app-layout">
        <aside className="sidebar">
          <div className="sidebar-logo">
            <h1>Invoice Manager</h1>
            <div className="tagline">Start Designs · Ecomheroes</div>
          </div>

          <div className="company-switcher">
            <select value={activeCompany?.id || ''} onChange={handleCompanyChange}>
              {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>

          <nav className="sidebar-nav">
            <NavLink to="/" end className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="icon">📊</span><span>Dashboard</span>
            </NavLink>
            <NavLink to="/clients" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="icon">👥</span><span>Clients</span>
            </NavLink>
            <NavLink to="/invoices" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="icon">🧾</span><span>Invoices</span>
            </NavLink>
            <NavLink to="/settings" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <span className="icon">⚙️</span><span>Settings</span>
            </NavLink>
          </nav>

          <div className="sidebar-footer">
            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginBottom: 8 }}>{user?.email}</div>
            <button className="logout-btn" onClick={handleLogout}>Sign out</button>
          </div>
        </aside>

        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </CompanyContext.Provider>
  );
}
